import { IClinician } from '../../../requester/request/request.types';
import { IMedicalOpinion, MedicalOpinionStatus } from '../types/medical-opinion.types';

/**
 * Medical Opinion model class (based on OpenAPI MedicalOpinionOut)
 */
export class MedicalOpinion implements Required<IMedicalOpinion> {
    entityId: string;
    zTouchTimestamp: string | null;
    zCreationTimestamp: string | null;
    opinion: string;
    attachment: string | null;
    status: MedicalOpinionStatus;
    requestId: string;
    expertId: string;
    expert: IClinician | null;
    requester: IClinician | null;
    ztouchTimestamp: string;
    zcreationTimestamp: string;

    /**
     * Returns formatted creation date
     */
    get createdAtFormatted(): string {
        if (!this.zcreationTimestamp) return 'Unknown';
        
        try {
            const date = new Date(this.zcreationTimestamp);
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        } catch {
            return 'Invalid date';
        }
    }

    /**
     * Returns whether opinion has attachment
     */
    get hasAttachment(): boolean {
        return !!this.attachment;
    }

    /**
     * Returns opinion preview (first 150 characters)
     */
    get preview(): string {
        if (this.opinion.length <= 150) {
            return this.opinion;
        }
        return this.opinion.substring(0, 150) + '...';
    }

    /**
     * Returns the primary ID
     */
    get id(): string {
        return this.entityId;
    }

    /**
     * Returns whether opinion is a draft
     */
    get isDraft(): boolean {
        return this.status === 'DRAFT';
    }

    /**
     * Returns whether opinion has been sent
     */
    get isSent(): boolean {
        return this.status === 'SENT';
    }

    constructor(opinion: IMedicalOpinion) {
        this.entityId = opinion.entityId;
        this.zTouchTimestamp = opinion.zTouchTimestamp || null;
        this.zCreationTimestamp = opinion.zCreationTimestamp || null;
        this.opinion = opinion.opinion;
        this.attachment = opinion.attachment || null;
        this.status = opinion.status;
        this.requestId = opinion.requestId;
        this.expertId = opinion.expertId;
        this.expert = opinion.expert || null;
        this.requester = opinion.requester || null;
        this.ztouchTimestamp = opinion.ztouchTimestamp;
        this.zcreationTimestamp = opinion.zcreationTimestamp;
    }

    /**
     * Converts to DTO for API requests
     */
    toDTO(): IMedicalOpinion {
        return {
            entityId: this.entityId,
            zTouchTimestamp: this.zTouchTimestamp,
            zCreationTimestamp: this.zCreationTimestamp,
            opinion: this.opinion,
            attachment: this.attachment,
            status: this.status,
            requestId: this.requestId,
            expertId: this.expertId,
            expert: this.expert,
            requester: this.requester,
            ztouchTimestamp: this.ztouchTimestamp,
            zcreationTimestamp: this.zcreationTimestamp
        };
    }
}